<template>
  <div
    class="owc-text-media-module-text-block wb-grid-row"
    :class="{
      'owc-text-media-module-text-block--dark': isDarkModeOn,
    }"
  >
    <p
      v-if="subtitle"
      class="owc-text-media-module-text-block__subtitle wb-grid-col-mq1-12"
      v-html="subtitle"
    ></p>
    <!--TODO: THIS IS NOT CORRECT. Right now the only way to have an h1 is to add a stage
    to the page. This related to this page https://confluence.mercedes-benz.io/display/OWC/Changes+that+need+more+than+just+FE-->
    <h2
      v-if="headline"
      class="owc-text-media-module-text-block__headline wb-grid-col-mq1-12"
      v-html="headline"
    ></h2>
    <p
      v-if="description"
      :class="[
        // Full width when there is a media block
        containsMedia ? 'wb-grid-col-mq3-12' : 'wb-grid-col-mq3-8',
        hasHeadline ? 'owc-text-media-module-text-block--has-headline' : '',
        'owc-text-media-module-text-block__description owc-rte-stylings',
        'wb-grid-col-mq1-12',
      ]"
      v-html="description"
    ></p>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { TextBlockComponent } from '@owc-packages/TextMediaModule/src/TextMediaModule';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

/**
 * OWC TextBlock - this is a subcomponent for OWC TextMediaModule Component
 *
 * @vue-prop {Boolean} [darkMode=fase] - Dark Mode flag
 */
export default (ComponentInitializeDispatcher as TextBlockComponent).extend({
  props: {
    darkMode: {
      type: Boolean,
      default: false,
    },
    containsMedia: {
      type: Boolean,
      default: false,
    },
    hasHeadline: {
      type: Boolean,
      default: false,
    },
    textBlockData: {
      type: Object,
      required: true,
    },
  },
  mixins: [OwcDataComponent],
  computed: {
    isDarkModeOn: function() {
      return this.darkMode;
    },
    subtitle: function() {
      return this.textBlockData.subtitle;
    },
    headline: function() {
      return this.textBlockData.headline;
    },
    description: function() {
      return this.textBlockData.description;
    },
  },
});
</script>

<style lang="scss">
@import '@owc-styles/utils/rte';

// This component accepts and renders arbitrary HTML coming from richtext fields from AEM
// To style the elements from that HTML (eg. anchor, strong, italic) we can't have the scoped styles
// since they'll never have the data-attribute that Vue uses to implment the scope
$moduleName: 'owc-text-media-module-text-block';

.#{$moduleName} {
  @include wb-type-copy;
  @include breakpoint-from(mq3) {
    margin-bottom: 0;
  }

  .#{$moduleName} {
    &__subtitle,
    &__description {
      color: var(--wb-grey-45);

      b {
        font-size: 1.2rem;
      }
    }
    &__subtitle {
      @include wb-type-copy-secondary;

      margin-bottom: var(--wb-spacing-xxs);
    }
    &__headline {
      @include wb-type-heading-l;
      color: var(--wb-grey-20);
    }
  }
  // Authors can add anchors and lists, since this rules were normalized & reseted, we need
  // to specify which rules we want for our elements
  a {
    @include wb-link;
    @include wb-link--inline;
  }
  &--dark {
    .#{$moduleName} {
      &__subtitle,
      &__description {
        color: var(--wb-grey-70);
      }
      &__headline {
        color: var(--wb-white);
      }
    }
  }
  &--has-headline {
    margin-top: var(--wb-spacing-xs);
  }
}
</style>
